import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "aside-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "filters-title has-text-weight-semibold" }, "Filters", -1)
const _hoisted_3 = {
  key: 0,
  class: "savedviews-select-container aside-content-savedviews m-bottom-12"
}
const _hoisted_4 = { class: "saved-view-btns" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "filter-inputs" }
const _hoisted_7 = {
  key: 0,
  class: "filters checkbox-section"
}
const _hoisted_8 = { class: "is-mobile level m-right-8" }
const _hoisted_9 = {
  class: "side-filter-icons",
  "aria-hidden": "true"
}
const _hoisted_10 = { class: "level-item" }
const _hoisted_11 = { class: "filters-submit aside-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrButton = _resolveComponent("NrButton")!
  const _component_NrIcon = _resolveComponent("NrIcon")!
  const _component_NrTooltip = _resolveComponent("NrTooltip")!
  const _component_NrSelect = _resolveComponent("NrSelect")!
  const _component_NrIconButton = _resolveComponent("NrIconButton")!
  const _component_NrModal = _resolveComponent("NrModal")!
  const _component_NrFormInput = _resolveComponent("NrFormInput")!
  const _component_NrFormLabel = _resolveComponent("NrFormLabel")!
  const _component_NrDatepicker = _resolveComponent("NrDatepicker")!

  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(`request-page-sidefilter ${
      $props.sidebarHasMinWidth ? 'request-sidefilter-min-width' : ''
    }`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_NrButton, {
        class: "reset-filters-btn",
        variant: "minimal-neutral",
        "aria-label": "Reset Filters",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.handleSavedView(null)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Reset filters ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(`aside-content has-background-white-bis ${
        $data.device === 'isMobile' ? 'm-right-12' : ''
      } ${_ctx.isSmallScreen() ? '' : 'specified-height-aside'}`)
    }, [
      ($props.notGuest)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_NrSelect, {
              "onOption:deselecting": $options.handleSavedView,
              onInput: $options.handleSavedView,
              options: _ctx.savedViews,
              modelValue: _ctx.selectedSavedView,
              label: "filter_name",
              placeholder: "Select or search"
            }, {
              label: _withCtx(() => [
                _createVNode(_component_NrTooltip, {
                  label: "Select filters then click the create filtered view button.",
                  position: "right"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Saved filtered views "),
                    _createVNode(_component_NrIcon, {
                      class: "inline-icon",
                      name: "info-circle"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onOption:deselecting", "onInput", "options", "modelValue"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_NrButton, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($data.isComponentModalActive = true)),
                disabled: $options.allFiltersDeselected,
                "aria-label": "Apply filters to create a new view",
                variant: "bordered-neutral"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Create filtered view ")
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_NrTooltip, {
                label: 
              !!_ctx.selectedSavedView
                ? 'Delete current active saved view'
                : 'Please select a saved view to delete'
            ,
                position: "left"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_NrIconButton, {
                    variant: "bordered-danger",
                    icon: { name: 'trash-alt' },
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($data.isDeleteModalActive = true)),
                    disabled: !_ctx.selectedSavedView,
                    class: "saved-view-btns-delete",
                    "aria-label": "Delete active saved view"
                  }, null, 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_NrModal, {
        class: "saved-view-delete-modal",
        show: $data.isDeleteModalActive,
        title: "Delete saved view",
        "primary-button-text": "Delete saved view",
        onOnPrimaryClick: $options.handleDeleteSavedView,
        onOnSecondaryClick: _cache[3] || (_cache[3] = ($event: any) => ($data.isDeleteModalActive = false)),
        onOnCloseClick: _cache[4] || (_cache[4] = ($event: any) => ($data.isDeleteModalActive = false)),
        "has-secondary-button": ""
      }, {
        default: _withCtx(() => [
          (_ctx.selectedSavedView)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, " You are about to delete the saved view “" + _toDisplayString(_ctx.selectedSavedView.filter_name) + "”. This action cannot be undone. Do you want to continue? ", 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["show", "onOnPrimaryClick"]),
      _createVNode(_component_NrModal, {
        show: $data.isComponentModalActive,
        title: "Save View",
        "primary-button-text": "Save",
        onOnPrimaryClick: $options.handleEmitSaveView,
        onOnSecondaryClick: _cache[6] || (_cache[6] = ($event: any) => ($data.isComponentModalActive = false)),
        onOnCloseClick: _cache[7] || (_cache[7] = ($event: any) => ($data.isComponentModalActive = false)),
        "has-secondary-button": "",
        disableButtons: !$data.saveViewName.length
      }, {
        default: _withCtx(() => [
          _createVNode(_component_NrFormInput, {
            maxLength: "30",
            label: "Save view",
            placeholder: "Name your saved view",
            required: "",
            modelValue: $data.saveViewName,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.saveViewName) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["show", "onOnPrimaryClick", "disableButtons"]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_NrFormInput, {
          label: "Search requests",
          modelValue: _ctx.filters['search_term'],
          "aria-label": "Type here to filter by document name",
          placeholder: "Search by keyword in a request",
          withTooltip: "",
          iconTooltipText: "ctrl + enter to apply filters",
          id: "request-search-field",
          onInput: _cache[8] || (_cache[8] = ($event: any) => ($options.setFilters({ search_term: $event }))),
          onFocus: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('onSearchRequestFieldFocus'))),
          onFocusout: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('onSearchRequestFieldFocusOut')))
        }, null, 8, ["modelValue"]),
        ($props.currentUser && $options.myId)
          ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
              _createVNode(_component_NrFormLabel, null, {
                default: _withCtx(() => [
                  _createTextVNode("My requests")
                ]),
                _: 1
              }),
              ($props.notGuest)
                ? (_openBlock(), _createBlock(_component_NrFormInput, {
                    key: 0,
                    type: "checkbox",
                    class: "checkbox",
                    label: "Point of contact",
                    modelValue: $options.isMyRequestChecked('request_poc_ids'),
                    onInput: _cache[11] || (_cache[11] = ($event: any) => ($options.formatMyRequestsFilter('request_poc_ids', $event)))
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              ($props.notGuest)
                ? (_openBlock(), _createBlock(_component_NrFormInput, {
                    key: 1,
                    type: "checkbox",
                    class: "checkbox",
                    label: "Staff",
                    modelValue: $options.isMyRequestChecked('request_helper_ids'),
                    onInput: _cache[12] || (_cache[12] = ($event: any) => ($options.formatMyRequestsFilter('request_helper_ids', $event)))
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              _createVNode(_component_NrFormInput, {
                type: "checkbox",
                label: "Requester",
                class: "checkbox",
                modelValue: $options.isMyRequestChecked('requester_ids'),
                onInput: _cache[13] || (_cache[13] = ($event: any) => ($options.formatMyRequestsFilter('requester_ids', $event)))
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.filtersJson.checkboxes, (section, index) => {
          return (_openBlock(), _createElementBlock("section", {
            key: index + section.name,
            class: "filters checkbox-section"
          }, [
            ($options.canShowFilterLabelForGuest(section))
              ? (_openBlock(), _createBlock(_component_NrFormLabel, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(section.name), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredFields(section.checkboxes), (item, index) => {
              return (_openBlock(), _createBlock(_component_NrFormInput, {
                key: index,
                class: "checkbox",
                type: "checkbox",
                modelValue: _ctx.filters[item.field],
                onInput: ($event: any) => ($options.setFilters({ [item.field]: $event }))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_NrIcon, {
                        name: item.icon,
                        class: "m-right-8"
                      }, null, 8, ["name"])
                    ]),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(item.label), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["modelValue", "onInput"]))
            }), 128))
          ]))
        }), 128)),
        (
            $options.canShowFilterField({
              field: 'request_date_start_date',
              showGuest: false
            })
          )
          ? (_openBlock(), _createBlock(_component_NrDatepicker, {
              key: 1,
              modelValue: _ctx.filters['request_date_start_date'],
              maxDate: _ctx.filters['request_date_end_date'],
              onInput: _cache[14] || (_cache[14] = ($event: any) => ($options.setFilters({ request_date_start_date: $event })))
            }, {
              label: _withCtx(() => [
                _createTextVNode("Request date (start)")
              ]),
              trigger: _withCtx(() => [
                _createVNode(_component_NrIcon, { name: "calendar-alt" })
              ]),
              _: 1
            }, 8, ["modelValue", "maxDate"]))
          : _createCommentVNode("", true),
        (
            $options.canShowFilterField({
              field: 'request_date_end_date',
              showGuest: false
            })
          )
          ? (_openBlock(), _createBlock(_component_NrDatepicker, {
              key: 2,
              modelValue: _ctx.filters['request_date_end_date'],
              minDate: _ctx.filters['request_date_start_date'],
              onInput: _cache[15] || (_cache[15] = ($event: any) => ($options.setFilters({ request_date_end_date: $event })))
            }, {
              label: _withCtx(() => [
                _createTextVNode("Request date (end)")
              ]),
              trigger: _withCtx(() => [
                _createVNode(_component_NrIcon, { name: "calendar-alt" })
              ]),
              _: 1
            }, 8, ["modelValue", "minDate"]))
          : _createCommentVNode("", true),
        (
            $options.canShowFilterField({
              field: 'due_date_start_date',
              showGuest: false
            })
          )
          ? (_openBlock(), _createBlock(_component_NrDatepicker, {
              key: 3,
              modelValue: _ctx.filters['due_date_start_date'],
              maxDate: _ctx.filters['due_date_end_date'],
              onInput: _cache[16] || (_cache[16] = ($event: any) => ($options.setFilters({ due_date_start_date: $event })))
            }, {
              label: _withCtx(() => [
                _createTextVNode("Due date (start)")
              ]),
              trigger: _withCtx(() => [
                _createVNode(_component_NrIcon, { name: "calendar-alt" })
              ]),
              _: 1
            }, 8, ["modelValue", "maxDate"]))
          : _createCommentVNode("", true),
        (
            $options.canShowFilterField({
              field: 'due_date_end_date',
              showGuest: false
            })
          )
          ? (_openBlock(), _createBlock(_component_NrDatepicker, {
              key: 4,
              modelValue: _ctx.filters['due_date_end_date'],
              minDate: _ctx.filters['due_date_start_date'],
              onInput: _cache[17] || (_cache[17] = ($event: any) => ($options.setFilters({ due_date_end_date: $event })))
            }, {
              label: _withCtx(() => [
                _createTextVNode("Due date (end)")
              ]),
              trigger: _withCtx(() => [
                _createVNode(_component_NrIcon, { name: "calendar-alt" })
              ]),
              _: 1
            }, 8, ["modelValue", "minDate"]))
          : _createCommentVNode("", true),
        (_ctx.$ability.can('read', 'staff_only_items'))
          ? (_openBlock(), _createBlock(_component_NrSelect, {
              key: 5,
              name: "poc",
              placeholder: "Search by name or email",
              options: 
            $options.parseOptionsForNrSelect(_ctx.filterOptions.pocs, 'name_with_email')
          ,
              loading: _ctx.filterFetchState.pocs.fetching,
              hasMore: !_ctx.filterFetchState.pocs.end,
              modelValue: $options.filterOptionValues('request_poc_ids'),
              filterable: false,
              onSearch: _cache[18] || (_cache[18] = ($event: any) => ($options.handleFilterTyping($event, 'pocs'))),
              onInput: _cache[19] || (_cache[19] = ($event: any) => ($options.handleAutogeneratedDataSelect($event, 'request_poc_ids'))),
              onLoadMore: _cache[20] || (_cache[20] = ($event: any) => ($options.handleFilterScroll('pocs'))),
              onOpen: _cache[21] || (_cache[21] = ($event: any) => ($options.handleFilterTyping($event, 'pocs'))),
              multiple: ""
            }, {
              label: _withCtx(() => [
                _createVNode(_component_NrTooltip, {
                  label: `Only point of contact active on at least one request will appear`,
                  position: "right"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Point of contact "),
                    _createVNode(_component_NrIcon, {
                      class: "inline-icon",
                      name: "info-circle"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["options", "loading", "hasMore", "modelValue"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.autoGenerateDataFilter, (filter, index) => {
          return (_openBlock(), _createBlock(_component_NrSelect, {
            key: index,
            name: filter.data,
            placeholder: filter.placeholder,
            options: 
            $options.parseOptionsForNrSelect(_ctx.filterOptions[filter.data], filter.field)
          ,
            loading: _ctx.filterFetchState[filter.data].fetching,
            hasMore: !_ctx.filterFetchState[filter.data].end,
            modelValue: $options.filterOptionValues(filter.dataKeyName),
            filterable: false,
            onSearch: ($event: any) => ($options.handleFilterTyping($event, filter.data)),
            onInput: ($event: any) => ($options.handleAutogeneratedDataSelect($event, filter.dataKeyName)),
            onLoadMore: ($event: any) => ($options.handleFilterScroll(filter.data)),
            onOpen: ($event: any) => ($options.handleFilterTyping($event, filter.data)),
            multiple: ""
          }, {
            label: _withCtx(() => [
              _createVNode(_component_NrTooltip, {
                label: `Only ${filter.label.toLowerCase()} active on at least one request will appear`,
                position: "right"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(filter.label) + " ", 1),
                  _createVNode(_component_NrIcon, {
                    class: "inline-icon",
                    name: "info-circle"
                  })
                ]),
                _: 2
              }, 1032, ["label"])
            ]),
            _: 2
          }, 1032, ["name", "placeholder", "options", "loading", "hasMore", "modelValue", "onSearch", "onInput", "onLoadMore", "onOpen"]))
        }), 128)),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_NrButton, {
            class: "m-right-12 is-hidden-desktop",
            variant: "bordered-primary",
            "aria-label": "Cancel",
            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.$emit('toggle-filter')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Cancel ")
            ]),
            _: 1
          }),
          _createVNode(_component_NrTooltip, { label: "ctrl+enter to apply filters" }, {
            default: _withCtx(() => [
              _createVNode(_component_NrButton, {
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.$emit('apply-filters')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Apply filters ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ], 2)
  ], 2))
}